module.exports = __webpack_public_path__ + "static/media/room-deluxeworld-2.ca898480.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/room-deluxeworld-2.jpg
// module id = 675
// module chunks = 6